import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserLoyaltyProgramPatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserLoyaltyProgramCollection {
  [IDataKeys.userLoyaltyProgram]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserLoyaltyProgramService {
  static createUserLoyaltyProgram = (
    data: IUserLoyaltyProgramPatchData
  ): Promise<IJSONAPIUserLoyaltyProgramCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_LOYALTY_PROGRAMS,
          data,
        });
        resolve(response as IJSONAPIUserLoyaltyProgramCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_LOYALTY_PROGRAM);
        reject({ error });
      }
    });

  static getUserLoyaltyPrograms = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserLoyaltyProgramCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_LOYALTY_PROGRAMS,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserLoyaltyProgramCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_LOYALTY_PROGRAMS);
        reject({ error });
      }
    });

  static editUserLoyaltyProgram = (
    id: string,
    data: IUserLoyaltyProgramPatchData
  ): Promise<IJSONAPIUserLoyaltyProgramCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_LOYALTY_PROGRAM(id),
          data,
        });
        resolve(response as IJSONAPIUserLoyaltyProgramCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_LOYALTY_PROGRAM);
        reject({ error });
      }
    });

  static deleteUserLoyaltyProgram = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_LOYALTY_PROGRAM(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_LOYALTY_PROGRAM);
        reject({ error });
      }
    });
}
